export enum BreakPoints {
    MEDIUM = '576px',
    LARGE = '992px',
    XLARGE = '1400px'
}
